/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAddressesAddresspersonid200,
  GetApiV1PersonIdAddressesAddresspersonid401,
  GetApiV1PersonIdAddressesAddresspersonid404,
  GetApiV1PersonIdAddressesAddresspersonid500,
  GetApiV1PersonIdAddressesAddresspersonidPathParams,
  GetApiV1PersonIdAddressesAddresspersonidQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdAddressesAddresspersonid.ts";
import { personAddressDetailViewModelSchema } from "../personAddressDetailViewModelSchema.ts";

export const getApiV1PersonIdAddressesAddresspersonidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    addressPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonIdAddressesAddresspersonidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAddressesAddresspersonid200Schema = z.lazy(
  () => personAddressDetailViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdAddressesAddresspersonid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAddressesAddresspersonid401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAddressesAddresspersonid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAddressesAddresspersonid404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAddressesAddresspersonid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAddressesAddresspersonid500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAddressesAddresspersonid500>;

export const getApiV1PersonIdAddressesAddresspersonidQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonIdAddressesAddresspersonid200Schema,
  ) as unknown as ToZod<GetApiV1PersonIdAddressesAddresspersonidQueryResponse>;
